import { useState, useEffect } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Sparkles, RectangleVertical, Zap, Mic } from "lucide-react";

export const WHATS_NEW_VERSION = "2026-06-lucy25";
const STORAGE_KEY = "spclive_whatsnew_seen";

const FEATURES = [
    {
        Icon: Sparkles,
        title: "Lucy 2.5 Engine",
        desc: "Upgraded AI model — sharper 720p output with better prompt and reference accuracy.",
    },
    {
        Icon: RectangleVertical,
        title: "Portrait 9:16 Mode",
        desc: "Stream vertical for TikTok and Instagram Live. Flip the Output toggle before going live.",
    },
    {
        Icon: Zap,
        title: "Fast Mode",
        desc: "Even lower latency for premium streams — 4 credits per second while enabled.",
    },
    {
        Icon: Mic,
        title: "Mic to OBS",
        desc: "Send your voice to OBS alongside the transformed video. Clean passthrough, toggle anytime.",
    },
];

const FeatureRow = ({ Icon, title, desc }) => (
    <div className="flex gap-3 items-start">
        <div className="border border-blaze/40 bg-blaze/10 p-2 shrink-0">
            <Icon className="w-4 h-4 text-blaze" />
        </div>
        <div>
            <div className="font-mono text-xs uppercase tracking-[0.15em] text-white">{title}</div>
            <div className="text-xs text-white/50 leading-relaxed mt-1">{desc}</div>
        </div>
    </div>
);

export function WhatsNewDialog() {
    const [open, setOpen] = useState(false);

    useEffect(() => {
        if (localStorage.getItem(STORAGE_KEY) !== WHATS_NEW_VERSION) setOpen(true);
    }, []);

    const dismiss = () => {
        localStorage.setItem(STORAGE_KEY, WHATS_NEW_VERSION);
        setOpen(false);
    };

    return (
        <Dialog open={open} onOpenChange={(o) => !o && dismiss()}>
            <DialogContent
                className="bg-surface border-white/10 text-white sm:max-w-md"
                data-testid="whatsnew-dialog"
            >
                <DialogHeader>
                    <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-blaze">
                        What's New
                    </div>
                    <DialogTitle className="font-display font-bold uppercase text-2xl tracking-tight text-left">
                        SPCLIVE just leveled up
                    </DialogTitle>
                    <DialogDescription className="text-white/50 text-xs">
                        Four new upgrades are live in your Studio.
                    </DialogDescription>
                </DialogHeader>
                <div className="space-y-4 mt-1">
                    {FEATURES.map((f) => (
                        <FeatureRow key={f.title} {...f} />
                    ))}
                </div>
                <button
                    onClick={dismiss}
                    data-testid="whatsnew-dismiss-button"
                    className="mt-3 w-full bg-blaze hover:bg-blazeHover text-white font-mono uppercase tracking-[0.2em] text-xs py-3 transition-colors"
                >
                    Got it — take me streaming
                </button>
            </DialogContent>
        </Dialog>
    );
}
